<template>
    <div class="pd20">
        <div class="main">
            <div class="search-box"></div>
            <!-- list -->
            <div class="list-box">
                <el-table :data="list" show-overflow-tooltip border style="width: 100%">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column type="index" width="100" label="序号"></el-table-column>
                <el-table-column prop="id" label="ID" width="100"></el-table-column>
                <el-table-column prop="mark" label="编码"></el-table-column>
                <el-table-column prop="name" label="维度"></el-table-column>
                <el-table-column label="操作" width="180">
                    <template slot-scope="scope">
                        <el-button type="primary" size="mini" icon="el-icon-edit" @click="switchDialog('edit',scope.$index, scope.row)" circle></el-button>
                        <el-button type="danger" size="mini" icon="el-icon-delete" @click="removeHandle(scope.$index, scope.row)" circle></el-button>
                    </template>
                </el-table-column>
                </el-table>
            </div>
            <!-- 添加按钮 -->
            <el-button type="primary" class="addBtn" size="mini" icon="el-icon-circle-plus"  @click="switchDialog('add')" circle></el-button>
            <!-- 分页 -->
            <!-- <el-pagination class="pages" 
                :page-sizes="[25, 50, 75, 100]"
                @size-change="handleSizeChange" 
                @current-change="handleCurrentChange" 
                :page-size="pages.size" 
                :current-page="pages.page"
                background 
                layout="sizes,prev, pager, next" 
                :total="pages.count"> 
            </el-pagination> -->
            <!--  -->
            <div class="pages-box"></div>
        </div>
        <!-- 添加和修改表单 -->
        <el-dialog title="维度" :visible.sync="dimensionsDialog">
            <div class="dimensionsBox">
                <el-form >
                    <el-form-item label="维度名称" :label-width="formLabelWidth">
                        <el-input v-model="name"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dimensionsDialog = false">取 消</el-button>
                    <el-button type="primary" @click="saveDimensions">确 定</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { dimensionsList,dimensionsAdd,dimensionsDel } from "@/api/measurement";
export default {
    data() {
        return{
            list: [],
            pages: {},
            dimensionsDialog:false,
            name:'',
            objAry:{}
        }
    },
    props:['eid'],
    methods:{
        // 删除
        removeHandle(index,row){
            this.$confirm('是否确认删除?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                dimensionsDel({
                    id:row.id
                }).then((data)=>{
                    this.$message({
                        message: '删除成功！',
                        type: 'success'
                    });
                    this.pullData();
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                })      
            });

            
        },
        switchDialog(type_,index_,row_){
            this.dimensionsDialog = true;
            this.name = type_ == 'edit'?row_.name:'';
            this.objAry = {
                type:type_,
                index:index_,
                row:row_
            }
        },
        // 添加+修改维度
        saveDimensions(){
            this.dimensionsDialog = false;
            // 如果是修改就传id
            let obj = {
                eid:parseInt(this.eid),
                name:this.name
            };
            if(this.objAry.type == 'edit'){
                obj['id'] = this.objAry.row.id;
            }   
            dimensionsAdd(obj).then((data)=>{
                if(data.error >0){
                    this.$message(data.msg);
                    return
                }
                this.pullData();
            });
        },
        // 调整每页显示条数
        handleSizeChange(val) {
            this.pages.size = val;
            this.pullData();
        },
        // 触发分页
        handleCurrentChange(val) {
            this.pages.page = val;
            this.pullData();
        },
        pullData(){
            this.$showLoading();
            dimensionsList({
                eid:this.eid,
                page:this.pages?this.pages.page:null,  //页码，默认1
                size:this.pages?this.pages.size:null,   //每页数量，默认25
            }).then((data)=>{
                this.list = data.list;
                this.pages = data.pager;
                this.$hideLoading();
            }).catch((err)=>{
                this.$hideLoading();
            });
        }
    },
    created(){
        this.pullData();
    }
}
</script>

<style lang="scss" scoped>
.main{
  position: relative;
}
.addBtn{
  position: absolute;
  left: 0;
  bottom: 0;
}
.pages{
  text-align: right;
  margin-top: 30px;
}
.pages-box{
    height: 32px;
    margin-top: 30px;
}
</style>
<style lang="scss">
.dimensionsBox{
    .el-input input{
        background-color: #ffffff !important;
        color: #333333 !important;
    }
    .dialog-footer{
        text-align: right;
    }
}
</style>

